<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p class="text-gray-600 text-sm">{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button class="btn-tg-white" (click)="cancel()">Cancelar</button>
  <button mat-flat-button class="btn-tg-cancel" (click)="confirm()">
    {{ data.confirmLabel ?? 'Confirmar' }}
  </button>
</mat-dialog-actions>
